import getInquiryTokenQueryFunction from '@/common/queries/getInquiryTokenQuery/getInquiryToken.function.ts';
import { useMutation } from '@tanstack/react-query';

const useInquiryTokenQueryOptions = () => {
  return useMutation({
    mutationKey: ['getInquiryToken'],
    mutationFn: getInquiryTokenQueryFunction,
  });
};

export default useInquiryTokenQueryOptions;
